import { useState } from "react";
import {
  SettingsCard,
  SettingsNote,
  SettingsPanel,
  SettingsRow,
  SettingsSelectRow,
  SettingsToggle,
} from "../SettingsUI";

export function NotificationsSection() {
  const [messageTone, setMessageTone] = useState(true);
  const [groupTone, setGroupTone] = useState(true);
  const [callTone, setCallTone] = useState(true);
  const [desktopAlerts, setDesktopAlerts] = useState(true);
  const [showPreview, setShowPreview] = useState(true);
  const [reactionNotifs, setReactionNotifs] = useState(true);
  const [sound, setSound] = useState("default");
  const [quietHours, setQuietHours] = useState(false);

  return (
    <SettingsPanel title="Notifications" description="Messages, groups, sounds">
      <SettingsCard title="Messages">
        <SettingsToggle
          title="Message notifications"
          description="Show notifications for new direct messages"
          checked={messageTone}
          onChange={setMessageTone}
        />
        <SettingsToggle
          title="Show message preview"
          description="Display sender and message text in alerts"
          checked={showPreview}
          onChange={setShowPreview}
        />
        <SettingsToggle
          title="Reaction notifications"
          description="Notify when someone reacts to your messages"
          checked={reactionNotifs}
          onChange={setReactionNotifs}
        />
      </SettingsCard>

      <SettingsCard title="Groups">
        <SettingsToggle
          title="Group notifications"
          description="Show notifications for group conversations"
          checked={groupTone}
          onChange={setGroupTone}
        />
        <SettingsRow title="Group tone" description="Default" trailing={<span className="text-xs text-fg-subtle">Change</span>} />
      </SettingsCard>

      <SettingsCard title="Calls">
        <SettingsToggle
          title="Call notifications"
          description="Ring and alert for incoming voice calls"
          checked={callTone}
          onChange={setCallTone}
        />
        <SettingsRow title="Ringtone" description="Papaya Default" trailing={<span className="text-xs text-fg-subtle">Change</span>} />
      </SettingsCard>

      <SettingsCard title="Sound & desktop">
        <SettingsSelectRow
          title="Notification sound"
          value={sound}
          onChange={setSound}
          options={[
            { value: "default", label: "Default" },
            { value: "soft", label: "Soft chime" },
            { value: "alert", label: "Alert" },
            { value: "none", label: "None" },
          ]}
        />
        <SettingsToggle
          title="Desktop notifications"
          description="Allow browser notifications while Papaya Web is open"
          checked={desktopAlerts}
          onChange={setDesktopAlerts}
        />
        <SettingsToggle
          title="Quiet hours"
          description="Mute non-call alerts overnight"
          checked={quietHours}
          onChange={setQuietHours}
        />
      </SettingsCard>

      <SettingsNote>
        Browser permission may still be required before desktop notifications can appear.
      </SettingsNote>
    </SettingsPanel>
  );
}
